import { useMemo, useState, useEffect } from 'react';
import { transformProduct } from '@/utils/products';
import { productsForOrder } from '@/store/cart';
import useBundleOffersSummary from '@/hooks/useBundleOffersSummary';
import useProductTags from '@/hooks/useProductTags';
import { usePersonalizedProductsIds } from '@/contexts/PersonalizedProductsIdsContext.jsx';

export default function useSimilarAndFrequentProducts(frequentlyBoughtTogetherApiRes, similarProductsApiRes, a) {
  const [productsOrder, setProductsOrder] = useState();
  const { productTags } = useProductTags();
  const { bundleOffersSummary } = useBundleOffersSummary();
  const { personalizedProductsIds } = usePersonalizedProductsIds();

  useEffect(() => {
    const productsForOrder$ = productsForOrder.subscribe(setProductsOrder);

    // eslint-disable-next-line
    return () => {
      productsForOrder$.unsubscribe();
    };
  }, []);

  const frequent = useMemo(() => {
    if (!frequentlyBoughtTogetherApiRes || !frequentlyBoughtTogetherApiRes.length) return null;

    return frequentlyBoughtTogetherApiRes.map(p => ({
      ...p,
      ...transformProduct(
        p,
        null,
        undefined,
        productTags,
        bundleOffersSummary,
        undefined,
        undefined,
        undefined,
        personalizedProductsIds,
        a
      ),
    }));
  }, [frequentlyBoughtTogetherApiRes, productsOrder, personalizedProductsIds]);

  const similar = useMemo(() => {
    if (!similarProductsApiRes || !similarProductsApiRes.length) return null;

    return similarProductsApiRes.map(p => ({
      ...p,
      ...transformProduct(
        p,
        null,
        undefined,
        productTags,
        bundleOffersSummary,
        undefined,
        undefined,
        undefined,
        personalizedProductsIds,
        a
      ),
    }));
  }, [similarProductsApiRes, productsOrder, personalizedProductsIds]);

  return { frequent, similar };
}
